import React from 'react'

const distributionHigh = () => (
  <svg
    width="586"
    height="183"
    viewBox="0 0 586 183"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M529.764 171.916V182.844L585.642 182.944C584.692 182.873 583.743 182.796 582.794 182.712H585.645V181.712H573.545C558.592 179.792 543.87 176.437 529.764 171.916Z"
      fill="#D9E8ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M470.9 144.053V182.739L527.01 182.84V171.016C506.542 164.197 487.439 154.931 470.9 144.053Z"
      fill="#D9E8ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M412.037 87.8386V182.713H456.171L468.147 182.734V142.211C460.419 136.952 453.286 131.34 446.877 125.463C439.659 118.914 430.027 108.074 418.799 95.4373C416.604 92.9668 414.348 90.4277 412.037 87.8386Z"
      fill="#D9E8ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M353.176 28.8649V182.713H409.286V84.7609C392.51 66.044 373.068 45.1596 353.176 28.8649Z"
      fill="#B0D0DA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M294.313 0.505859V182.713H350.423V26.6421C331.395 11.5021 312.049 0.829752 294.313 0.505859Z"
      fill="#B0D0DA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M235.451 27.1274V182.713H291.561V0.53833C273.813 1.27388 254.424 12.0817 235.451 27.1274Z"
      fill="#B0D0DA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M176.588 84.9589V182.713H232.698V29.3428C212.589 45.7491 193.063 66.62 176.588 84.9589Z"
      fill="#B0D0DA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M117.725 141.583V182.713H173.834V88.0293C171.309 90.8529 168.863 93.6047 166.504 96.2579L166.503 96.2586C158.403 105.368 151.337 113.316 145.688 119.014C138.167 126.599 128.687 134.295 117.725 141.583Z"
      fill="#D9E8ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M58.8633 170.257V182.713H114.973V143.384C98.8001 153.801 79.6201 163.278 58.8633 170.257Z"
      fill="#D9E8ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.1098 182.713H1.16895V181.898L0 181.896C0.389738 181.875 0.779389 181.853 1.16895 181.829V181.713H2.96227C21.1658 180.448 39.1372 176.653 56.1098 171.165V182.713Z"
      fill="#D9E8ED"
    />
  </svg>
)

export default distributionHigh
